import type { DesktopIcon as DesktopIconType } from '../../stores/desktopStore'
import { useDesktopStore } from '../../stores/desktopStore'
import { useWindowStore } from '../../stores/windowStore'
import { Icon } from './Icon'
import './DesktopIcon.css'

interface DesktopIconProps {
  icon: DesktopIconType
}

export function DesktopIcon({ icon }: DesktopIconProps) {
  const selectedIcons = useDesktopStore((state) => state.selectedIcons)
  const selectIcon = useDesktopStore((state) => state.selectIcon)
  const setStartMenuOpen = useDesktopStore((state) => state.setStartMenuOpen)
  const openWindow = useWindowStore((state) => state.openWindow)

  const isSelected = selectedIcons.includes(icon.id)

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    selectIcon(icon.id)
    setStartMenuOpen(false)
  }

  const handleDoubleClick = () => {
    openWindow(icon.appId, icon.label, icon.icon)
  }

  return (
    <button
      className={`desktop-icon ${isSelected ? 'selected' : ''}`}
      style={{
        left: icon.position.x,
        top: icon.position.y,
      }}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      aria-label={`Open ${icon.label}`}
    >
      <div className="desktop-icon__image">
        <Icon name={icon.icon} size={32} />
      </div>
      <span className="desktop-icon__label">{icon.label}</span>
    </button>
  )
}
